import { ref } from "vue";
import { defineStore } from "pinia";

const usePrivateStore = defineStore("privateInfo", () => {
  const currentClickProductCode = ref(null);
  const modalVisible = ref(false);
  const privateInfo = ref({});
  const currentClickProduct = ref(null);
  
  const setCurrentClickProductCode = (value) => {
    currentClickProductCode.value = value;
  };
  const setCurrentClickProduct = (value) => {
    currentClickProduct.value = value;
  }
  const setModalVisible = (value) => {
    modalVisible.value = value;
  };
  const setPrivateInfo = (value) => {
    privateInfo.value = value;
  };

  return {
    currentClickProductCode,
    modalVisible,
    privateInfo,
    currentClickProduct,
    setCurrentClickProductCode,
    setModalVisible,
    setPrivateInfo,
    setCurrentClickProduct
  };
});

export default usePrivateStore;